module.exports = __webpack_public_path__ + "static/media/lock_icon.9c5946e2.svg";